import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function getLeadsTotal(cancelToken, page, perPage, assignedOnly, fields, responsibleUsers, states, origins, assigned_users_id, business_units, usersRoles, desde, hasta, groups, task_date, possible_groups, lead_temperature, searchCmbValue, includeClosedOlderThan60Days) {
  try {
    let endpointCallOptions = {}
    const endpoint = new URL(`${LEADS_ENDPOINT}/total`, window.location.href)
    endpoint.searchParams.append('dinamicPagination', true)

    if (searchCmbValue) { endpoint.searchParams.append('search', searchCmbValue) }
    if (assignedOnly) { endpoint.searchParams.append('assignedOnly', assignedOnly) }
    if (assigned_users_id) { assigned_users_id.forEach(v => { endpoint.searchParams.append('assigned_users_id[]', v) }) }
    if (business_units) { business_units.forEach(v => { endpoint.searchParams.append('business_units[]', v) }) }

    if (fields) { endpoint.searchParams.append('fields', fields) }
    if (page) { endpoint.searchParams.append('page', page) }
    if (perPage) { endpoint.searchParams.append('per_page', perPage) }

    if (origins) { origins.forEach(v => { endpoint.searchParams.append('origins[]', v) }) }
    if (responsibleUsers) { responsibleUsers.forEach(v => { endpoint.searchParams.append('responsibleUsers[]', v) }) }
    if (states) { states.forEach(v => { endpoint.searchParams.append('states[]', v) }) }
    if (usersRoles) { usersRoles.forEach(v => { endpoint.searchParams.append('usersRoles[]', v) }) }
    if (desde) { endpoint.searchParams.append('desde', desde) }
    if (hasta) { endpoint.searchParams.append('hasta', hasta) }
    if (groups) { groups.forEach(v => { endpoint.searchParams.append('groups[]', v) }) }
    if (possible_groups) { possible_groups.forEach(v => { endpoint.searchParams.append('possible_groups[]', v) }) }
    if (task_date) { endpoint.searchParams.append('task_date', task_date) }
    if (lead_temperature) { lead_temperature.forEach(v => { endpoint.searchParams.append('lead_temperature[]', v) }) }
    if (includeClosedOlderThan60Days === true || includeClosedOlderThan60Days === false || includeClosedOlderThan60Days === 'true' || includeClosedOlderThan60Days === 'false') {
      endpoint.searchParams.append('includeClosedOlderThan60Days', includeClosedOlderThan60Days)
    }

    if (cancelToken) {
        endpointCallOptions.cancelToken = cancelToken
    }
    endpointCallOptions.timeout = 180000 // 3 minutos
    const response = await axios.get(endpoint.href, endpointCallOptions)

    return response.data.data
  } catch (error) {
    if (axios.isCancel(error)) {
        return Promise.resolve()
    }
        console.log('error', error)
    return Promise.reject(error)
  }
}
